<template>
  <div class="overlay">
    <v-sheet class="pa-5">
      <div class="d-flex justify-end">
        <v-btn
          @click="save"
          class="default-action-btn"
          id="js-assign-save-button"
          >Save</v-btn
        >
      </div>
      <div class="row">
        <div class="col-5 mr-4">
          <h3>Available</h3>
          <v-skeleton-loader
            v-if="loading"
            height="250"
            width="300"
            type="image"
          >
          </v-skeleton-loader>
          <draggable
            v-else
            class="list-group"
            id="js-available-list"
            :list="available"
            group="selection"
          >
            <v-list-item
              :id="`js-available-${element.id}`"
              class="list-group-item"
              v-for="element in available"
              :key="element.id"
              @dblclick="autoMove"
            >
              <!-- <i class="fa fa-align-justify handle mr-2"></i> -->
              {{ element.name }}
            </v-list-item>
          </draggable>
        </div>

        <div class="col-5 ml-4">
          <h3>Assigned</h3>
          <v-skeleton-loader
            v-if="loading"
            height="250"
            width="300"
            type="image"
          >
          </v-skeleton-loader>
          <draggable
            v-else
            class="list-group"
            id="js-selected-list"
            :list="selected"
            group="selection"
          >
            <v-list-item
              :id="`js-selected-${element.id}`"
              class="list-group-item"
              v-for="element in selected"
              :key="element.id"
              @dblclick="autoMove"
            >
              <!-- <i class="fa fa-align-justify handle mr-2"></i> -->
              {{ element.name }}
            </v-list-item>
          </draggable>
        </div>
      </div>
      <div v-if="showNewAsCopy" class="row new-as-copy">
        <v-checkbox v-model="newAsCopy" label="New As Copy"></v-checkbox>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import eventMixin from "@/mixins/eventMixin"

export default {
  mixins: [eventMixin],
  components: {
    draggable
  },
  props: {
    available: { type: Array, default: [] },
    selected: { type: Array, default: [] },
    loading: { type: Boolean, default: false },
    showNewAsCopy: { type: Boolean, default: false }
  },
  data: function() {
    return {
      newAsCopy: false
    }
  },
  methods: {
    save: function(e) {
      this.$emit("save", {
        available: this.available,
        selected: this.selected,
        newAsCopy: this.newAsCopy
      })
    },
    autoMove: function(e) {
      const elId = e.target.id
      const objId = elId.split("-").slice(-1)[0]
      const sourceList = elId.includes("available", 0)
        ? this.available
        : this.selected
      const destList = elId.includes("selected", 0)
        ? this.available
        : this.selected

      for (var i = 0; i < sourceList.length; i++) {
        if (sourceList[i].id == objId) {
          const removedItem = sourceList.splice(i, 1)
          destList.push(removedItem[0])
          i--
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables";
@import "../scss/buttons";

div.overlay {
  min-width: 180px;
  max-width: 100%;
}
div.v-sheet {
  padding: 15px;
  width: 100%;
}
.list-group {
  background-color: #eaeaea;
  min-height: 250px;
  width: 80%;
}

.handle {
  float: left;
  padding-top: 8px;
  padding-bottom: 8px;
}
div.list-group {
  height: 30vh;
  overflow: scroll;
  width: 100%;
}
div.list-group {
  min-width: 150px;
}

.new-as-copy {
  padding: 0px 10px;
}
</style>
